import React from 'react';
import { Button, ButtonGroup } from '@mui/material';

const TabPanelButtonGroup = ({ selectedTabs, onTabClick }) => {
  // Helper function to determine button variant based on selection state
  const getButtonVariant = (tabName) => {
    return selectedTabs.includes(tabName) ? 'contained' : 'outlined';
  };

  // Define available tabs and their labels
  const tabs = [
    { id: 'callHistory', label: 'Call History' },
    { id: 'dispatchHistory', label: 'Dispatch History' },
    { id: 'invoiceHistory', label: 'Invoice History' },
    { id: 'paymentsHistory', label: 'Payments History' },
    { id: 'proposals', label: 'Proposals / Jobs' },
    { id: 'violations', label: 'Violations' },
    { id: 'inspections', label: 'Inspections' }
  ];

  return (
    <ButtonGroup>
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          onClick={() => onTabClick(tab.id)}
          variant={getButtonVariant(tab.id)}
        >
          {tab.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default TabPanelButtonGroup;